import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  crudGetOne as crudGetOneAction,
  crudGetMatching as crudGetMatchingAction,
} from 'admin-on-rest';
import equal from 'deep-equal';
import { getPossibleReferences } from 'admin-on-rest/lib/reducer/admin/references/possibleValues';

const referenceSource = (resource, source) => `${resource}@${source}`;

export class ReferenceInput extends Component {
  componentDidMount() {
    this.fetchReferenceAndOptions(this.props);
  }

  componentWillReceiveProps = (nextProps) => {
    if (!equal(this.props.references, nextProps.references)) {
      this.fetchReferenceAndOptions(nextProps);
    }
  }

  fetchReferenceAndOptions(
    { references, resource }
  ) {
    references.forEach((reference) => {
      const { name, sort = { field: 'id', order: 'DESC' }, filter = {} } = reference;
      this.props.crudGetMatching(
        name,
        referenceSource(resource, name),
        { page: 1, perPage: 10000 },
        sort,
        filter
      );
    });
  }

  render() {
    const {
      resource,
      matchingReferences,
      onChange,
      children,
      meta,
      record,
    } = this.props;

    return React.cloneElement(children, {
      resource,
      meta,
      fetchReferences: () => this.fetchReferenceAndOptions(),
      choices: matchingReferences,
      onChange,
      translateChoice: false,
      record,
    });
  }
}

ReferenceInput.propTypes = {
  children: PropTypes.element,
  crudGetMatching: PropTypes.func,
  matchingReferences: PropTypes.object,
  meta: PropTypes.object,
  onChange: PropTypes.func,
  resource: PropTypes.string,
};

ReferenceInput.defaultProps = {
  matchingReferences: {},
};

function mapStateToProps(state, props) {
  const matchingReferences = {};
  props.references.forEach(({ name }) => {
    // console.log(referenceSource(props.resource, name));
    matchingReferences[name] = getPossibleReferences(
      state,
      referenceSource(props.resource, name),
      name,
    );
  });
  return {
    matchingReferences,
  };
}

const ConnectedReferenceInput = connect(mapStateToProps, {
  crudGetOne: crudGetOneAction,
  crudGetMatching: crudGetMatchingAction,
})(ReferenceInput);

ConnectedReferenceInput.defaultProps = {
  addField: true,
};

export default ConnectedReferenceInput;
